import { render, staticRenderFns } from "./authenticatedLayout.vue?vue&type=template&id=2e0b517e&scoped=true&lang=pug"
import script from "./authenticatedLayout.vue?vue&type=script&lang=js"
export * from "./authenticatedLayout.vue?vue&type=script&lang=js"
import style0 from "./authenticatedLayout.vue?vue&type=style&index=0&id=2e0b517e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0b517e",
  null
  
)

export default component.exports